import React from "react";
import { Typography, Collapse, Grid } from "antd";

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const faqQuestions = [
  "What is web hosting and why do I need it?",
  "How can I buy a hosting plan?",
  "What Kind of Support Does Web Hosting Have?",
  "Do You Offer a Web Hosting and Domain Package?",
  "What are the differences between website hosting and domain?",
  "What Are the CPU, RAM, Inode and Disk Limits of Managed Hostinger Plans?",
  "Can I migrate my existing website to Hostinger?",
  "Do I need web hosting services for WordPress?",
  "What Are the Benefits of Choosing Managed Web Hosting Services?",
  "Do I Need Technical Knowledge to Use Website Hosting Services?",
  "Does Managed Web Hosting Come With a Control Panel?",
];

export default function WebHostingFAQ() {
  const screens = useBreakpoint();

  return (
    <div
      style={{
        background: "#ffffff",
        padding: screens.md ? "80px 24px" : "60px 16px",
      }}
    >
      <div style={{ maxWidth: 1128, margin: "0 auto" }}>
        {/* Heading */}
        <Title
          level={2}
          style={{
            textAlign: "center",
            color: "#2d1e6b",
            marginBottom: 8,
          }}
        >
          Web Hosting FAQs
        </Title>

        <Text
          style={{
            display: "block",
            textAlign: "center",
            color: "#5f5c80",
            marginBottom: 48,
            fontSize: 15,
          }}
        >
          Find answers to frequently asked questions about website hosting
          services.
        </Text>

        {/* FAQ List */}
        <Collapse
          accordion
          bordered={false}
          showArrow={false}
          expandIcon={() => null}
          style={{ background: "transparent" }}
        >
          {faqQuestions.map((question, index) => (
            <Collapse.Panel
              key={index}
              header={
                <Text
                  style={{
                    color: "#2d1e6b",
                    fontSize: 16,
                    fontWeight: 500,
                  }}
                >
                  {question}
                </Text>
              }
              style={{
                border: "1px solid #d6d9ff",
                borderRadius: 8,
                marginBottom: 16,
              }}
            >
              {/* Empty on purpose — no answers */}
            </Collapse.Panel>
          ))}
        </Collapse>
      </div>
    </div>
  );
}
